export default __webpack_public_path__ + "static/media/FSEmericWeb-SemiBold.7326f02f.woff";